'use strict';
import isFunction from 'lodash/isFunction';
import omit from 'lodash/omit';
import 'rxjs/add/operator/delay';
import React, {Component} from 'react';
import * as T from 'prop-types';
import {parseCheckboxEvent} from '../../../core-utilities/react-form-utils';
import {getLastMidnight} from '../../redux/timerExports';
import {TimerExportView} from './TimerExportView';


export class TimerExportComponent extends Component {
  static propTypes = {
    targetData: T.object,
    format: T.string,
    filterOptions: T.object,
    status: T.string,
    showSuccess: T.bool,

    onChangeFormatXlsx: T.func,
    onChangeFormatCsv: T.func,
  };

  constructor(props) {
    super(props);

    this.handleChangeUseAfter = this.handleChangeUseAfter.bind(this);
    this.handleChangeAfterDate = this.handleChangeAfterDate.bind(this);
    this.handleChangeUseBefore = this.handleChangeUseBefore.bind(this);
    this.handleChangeBeforeDate = this.handleChangeBeforeDate.bind(this);
    this.handleUpdateFilterData = this.handleUpdateFilterData.bind(this);
  }

  handleChangeUseAfter(event) {
    this.handleChangeUseDate(event, 'useAfter', 'afterDate', getLastMidnight());
  }

  handleChangeAfterDate(value) {
    this.handleChangeDate(value, 'afterDate');
  }

  handleChangeUseBefore(event) {
    const midnight = new Date();
    midnight.setHours(0, 0, 0, 0);
    this.handleChangeUseDate(event, 'useBefore', 'beforeDate', midnight);
  }

  handleChangeBeforeDate(value) {
    this.handleChangeDate(value, 'beforeDate');
  }

  handleChangeUseDate(event, useProp, dateProp, newDate) {
    const value = !parseCheckboxEvent(event);
    if (this.props.filterOptions.dateRange[useProp] !== value) {
      if (value) {
        this.handleUpdateFilterData({
          filterOptions: {
            ...this.props.filterOptions,
            dateRange: {
              ...this.props.filterOptions.dateRange,
              [useProp]: true,
              [dateProp]: newDate,
            },
          },
        });
      } else {
        const nextState = omit(this.props.filterOptions.dateRange, [dateProp]);
        nextState[useProp] = false;
        this.handleUpdateFilterData({
          filterOptions: {
            ...this.props.filterOptions,
            dateRange: {
              ...nextState,
            },
          },
        });
      }
    }
  }

  handleChangeDate(value, dateProp) {
    if (this.props.filterOptions.dateRange[dateProp] !== value) {
      this.handleUpdateFilterData({
        filterOptions: {
          ...this.props.filterOptions,
          dateRange: {
            ...this.props.filterOptions.dateRange,
            [dateProp]: value,
          },
        },
      });
    }
  }

  render() {
    return (
      <TimerExportView
        {...this.props}
        onChangeUseAfter={this.handleChangeUseAfter}
        onChangeAfterDate={this.handleChangeAfterDate}
        onChangeUseBefore={this.handleChangeUseBefore}
        onChangeBeforeDate={this.handleChangeBeforeDate}
      />
    );
  }

  /**
   * @param {ReduxListExports~FilterData} payload
   */
  handleUpdateFilterData(payload) {
    if (isFunction(this.props.onUpdateFilterData)) {
      this.props.onUpdateFilterData(payload);
    }
  }
}



// WEBPACK FOOTER //
// ./src/js/timers/components/TimerExport/TimerExportComponent.js